import { render, staticRenderFns } from "./onCalls.vue?vue&type=template&id=c142a586&"
import script from "./onCalls.vue?vue&type=script&lang=js&"
export * from "./onCalls.vue?vue&type=script&lang=js&"
import style0 from "./onCalls.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports